import React from "react";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import {
	PagerContainer,
	PagerHeader,
	Span,
	PagerBody,
} from "../../styles/Pager";

function Pager(props) {
	return (
		<PagerContainer>
			<PagerHeader>
				<Span> 1-9 of 17 items</Span>
			</PagerHeader>
			<PagerBody>
				<ul className="pagination justify-content-center mb-0 pl-0 border-0">
					<li className="page-item disabled border-0">
						<a href="/" className="page-link border-0 text-muted" tabIndex="-1">
							<AiOutlineLeft /> PREVIOUS
						</a>
					</li>
					<li className="page-item border-0">
						<a href="/" className="page-link border-0 text-muted">
							1
						</a>
					</li>
					<li className="page-item border-0">
						<a href="/" className="page-link border-0 text-muted">
							2
						</a>
					</li>
					<li className="page-item border-0">
						<a href="/" className="page-link border-0 text-muted">
							NEXT <AiOutlineRight />
						</a>
					</li>
				</ul>
			</PagerBody>
		</PagerContainer>
	);
}

export default Pager;
